import { ReactNode } from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { CheckIcon } from "@radix-ui/react-icons";

export const Checkbox = ({
  label,
  id,
  ...props
}: CheckboxPrimitive.CheckboxProps & { label: ReactNode }) => {
  return (
    <div className="flex items-center" data-testid="container-checkbox-wrapper">
      <CheckboxPrimitive.Root
        {...props}
        className="border-black dark:border-cloud border-2 border-solid h-[25px] w-[25px] flex items-center justify-center min-w-[25px] focus:outline-clementine dark:focus:outline-sun outline-offset-4"
        id={id}
        data-testid={`check-checkbox-input-${id}`}
      >
        <CheckboxPrimitive.Indicator className="dark:text-cloud">
          <CheckIcon />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      <label className="pl-[15px] text-[15px] leading-none" htmlFor={id} data-testid="text-checkbox-label">
        {label}
      </label>
    </div>
  );
};


/*
POTENTIAL IMPROVEMENTS:
1. Accessibility: Add aria-label when no visible label is provided
2. Customization: Allow for different checkbox sizes and styles
3. Validation: Add support for error states and validation messages
4. Indeterminate state: Add support for indeterminate checkbox state
5. Animation: Add subtle animation for better user feedback on state change
6. Focus handling: Improve keyboard navigation and focus visualization
7. Group support: Create a CheckboxGroup component for related checkboxes
*/